import {
  UserPlus,
  FileText,
  ShieldCheck,
  Download,
  TrendingUp,
  Receipt,
  CalendarDays,
  CalendarPlus,
  ScrollText,
  UserRound,
  FolderDown,
  CheckCircle,
  Network,
} from "lucide-react";

import { normalizeRole, R } from "../rbac/access";

/**
 * Centralized Quick Actions for Payroll Dashboard (RBAC).
 */
export function normalizeDashboardRole(role) {
  return normalizeRole(role) || R.EMPLOYEE;
}

const managementActions = [
  {
    id: "add-employee",
    label: "Add Employee",
    cls: "qa-blue",
    Icon: UserPlus,
    action: { type: "navigate", path: "/employees/add" },
  },
  {
    id: "org-hierarchy",
    label: "Reporting Hierarchy",
    cls: "qa-teal",
    Icon: Network,
    action: { type: "navigate", path: "/org-hierarchy" },
  },
  {
    id: "gen-payslip",
    label: "Gen Payslip",
    cls: "qa-green",
    Icon: FileText,
    action: { type: "navigate", path: "/payslip" },
  },
  {
    id: "tax-declaration",
    label: "Tax Declaration",
    cls: "qa-teal",
    Icon: ShieldCheck,
    action: { type: "navigate", path: "/settings/tds/employee-tax" },
  },
  {
    id: "leave-import",
    label: "Leave Import",
    cls: "qa-amber",
    Icon: Download,
    action: { type: "navigate", path: "/settings/leave-setup" },
  },
  {
    id: "pf-report",
    label: "PF Report",
    cls: "qa-purple",
    Icon: TrendingUp,
    action: { type: "navigate", path: "/salary-statement?focus=pf" },
  },
  {
    id: "esi-report",
    label: "ESI Report",
    cls: "qa-red",
    Icon: ShieldCheck,
    action: { type: "navigate", path: "/salary-statement?focus=esi" },
  },
];

const managerActions = [
  {
    id: "approve-leave",
    label: "Approve Leave",
    cls: "qa-blue",
    Icon: CheckCircle,
    action: { type: "navigate", path: "/leave?tab=approval" },
  },
  {
    id: "team-attendance",
    label: "Team Attendance",
    cls: "qa-teal",
    Icon: CalendarDays,
    action: { type: "navigate", path: "/attendance/overview" },
  },
  {
    id: "apply-leave-mgr",
    label: "Apply Leave",
    cls: "qa-green",
    Icon: CalendarPlus,
    action: { type: "navigate", path: "/leave" },
  },
  {
    id: "view-payslip-mgr",
    label: "My Payslip",
    cls: "qa-purple",
    Icon: Receipt,
    action: { type: "navigate", path: "/payslip" },
  },
  {
    id: "my-attendance-mgr",
    label: "My Attendance",
    cls: "qa-amber",
    Icon: CalendarDays,
    action: { type: "navigate", path: "/attendance" },
  },
  {
    id: "my-team",
    label: "My Team",
    cls: "qa-red",
    Icon: UserRound,
    action: { type: "navigate", path: "/org-hierarchy" },
  },
];

const employeeActions = [
  {
    id: "view-payslip",
    label: "View Payslip",
    cls: "qa-green",
    Icon: Receipt,
    action: { type: "navigate", path: "/payslip" },
  },
  {
    id: "my-attendance",
    label: "My Attendance",
    cls: "qa-blue",
    Icon: CalendarDays,
    action: { type: "navigate", path: "/my-attendance" },
  },
  {
    id: "apply-leave",
    label: "Apply Leave",
    cls: "qa-teal",
    Icon: CalendarPlus,
    action: { type: "navigate", path: "/leave?tab=apply" },
  },
  {
    id: "my-tax-declaration",
    label: "My Tax Declaration",
    cls: "qa-amber",
    Icon: ScrollText,
    action: { type: "navigate", path: "/form16" },
  },
  {
    id: "profile-settings",
    label: "Profile / Settings",
    cls: "qa-purple",
    Icon: UserRound,
    action: { type: "navigate", path: "/profile" },
  },
  {
    id: "download-documents",
    label: "Download Documents",
    cls: "qa-red",
    Icon: FolderDown,
    action: { type: "navigate", path: "/employees?module=employees" },
  },
];

export const roleActions = {
  [R.ADMIN]: managementActions,
  [R.HR]: managementActions,
  [R.MANAGER]: managerActions,
  [R.EMPLOYEE]: employeeActions,
};

export function getQuickActionsForRole(role) {
  const r = normalizeDashboardRole(role);
  return roleActions[r] ?? roleActions[R.EMPLOYEE];
}
